import { type RequestDocumentHandlerSchema } from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/schemas/requestDocumentHandler'
import { HandlerFormComponentPayload } from 'modules/workflows/contexts/WorkflowContext'
import { DEFAULT_DURATION_UNIT, isValidDateUnit } from 'modules/workflows/lib/durationUnit'

import { mapEmployeeSegments } from './employeeSegmentMapper'

export const requestDocumentNodeToSchemaMapper = (
  payload: HandlerFormComponentPayload
): RequestDocumentHandlerSchema['nodeData']['payload'] => {
  const due_on_value = payload.due_on_value
  const numericDueOnValue =
    typeof due_on_value === 'number' && !isNaN(due_on_value) ? due_on_value : 2

  const due_on_unit = String(payload.due_on_unit)

  const assigneeIds = Array.isArray(payload.assignee_ids)
    ? payload.assignee_ids.map((id) => Number(id))
    : undefined

  const fallbackAssigneeIds = Array.isArray(payload.fallback_assignee_ids)
    ? payload.fallback_assignee_ids.map((id) => Number(id))
    : undefined

  const assigneeSegments = mapEmployeeSegments(payload.assignee_segments)
  const fallbackAssigneeSegments = mapEmployeeSegments(payload.fallback_assignee_segments)

  return {
    title: typeof payload.title === 'string' ? payload.title : '',
    description: typeof payload.description === 'string' ? payload.description : '',
    assignee_ids: assigneeIds,
    assignee_segments: assigneeSegments,
    fallback_assignee_ids: fallbackAssigneeIds,
    fallback_assignee_segments: fallbackAssigneeSegments,
    due_on_unit: isValidDateUnit(due_on_unit) ? due_on_unit : DEFAULT_DURATION_UNIT,
    due_on_value: numericDueOnValue,
  }
}
